/* eslint-disable import/prefer-default-export */
import { keyframes } from 'styled-components';

export const addLeftPadding = value => keyframes`
0% {
  padding-left: 0;
}
100% {
  padding-left: ${value};
}
`;
